module.exports = __webpack_public_path__ + "static/fipcrosebunny1-d37661f8edbe3a646ab084c804cc72fe.jpeg";